import { useState } from "react";
import { tracks } from "../data";
import SectionHeading from "./SectionHeading";

export default function TracksSection() {
  const [active, setActive] = useState(0);
  const current = tracks[active];

  return (
    <section id="tracks" className="bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <SectionHeading
          eyebrow="Tracks"
          title="主题赛道分类"
          desc="同一份经历，放在不同赛道里会得到不同的解读。选题前先看看哪条赛道更贴合你的故事。"
        />

        <div className="mt-8 md:mt-10 flex flex-wrap gap-2" role="tablist" aria-label="赛道分类">
          {tracks.map((track, index) => (
            <button
              key={track.key}
              type="button"
              role="tab"
              aria-selected={active === index}
              onClick={() => setActive(index)}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${
                active === index
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700 border border-background-200"
              }`}
            >
              <i className={track.icon} aria-hidden="true"></i>
              {track.name}
            </button>
          ))}
        </div>

        <div className="mt-6 p-6 md:p-10 rounded-lg bg-background-100 border border-background-200">
          <div className="grid grid-cols-1 lg:grid-cols-[auto,1fr] gap-6 lg:gap-10 items-center">
            <span className="w-16 h-16 md:w-20 md:h-20 rounded-lg bg-foreground-950 text-accent-400 flex items-center justify-center">
              <i className={`${current.icon} text-3xl md:text-4xl`} aria-hidden="true"></i>
            </span>
            <div>
              <div className="flex flex-wrap items-center gap-3">
                <h3 className="font-heading text-xl md:text-2xl font-black text-foreground-950">
                  {current.name}
                </h3>
                <span className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs">
                  {current.count}
                </span>
              </div>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
                {current.desc}
              </p>
              <a
                href="#stories"
                className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
              >
                看看这条赛道的作品
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}